import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "palette-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 5.62a1.02 1.02 0 1 0 1.03 1.03v-.01c-.01-.55-.46-1.02-1.03-1.02ZM7.67 12a1.02 1.02 0 1 0 0 0ZM15.06 7.5a1.02 1.02 0 1 1 1.45 1.44 1.02 1.02 0 0 1-1.45-1.45ZM8.94 15.06a1.02 1.02 0 1 0-1.45 1.44 1.02 1.02 0 0 0 1.45-1.44ZM8.94 7.49A1.02 1.02 0 1 1 7.5 8.94 1.02 1.02 0 0 1 8.94 7.5Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.75 13v-1c0-5.48-4.52-9.9-10.03-9.75a9.85 9.85 0 0 0-9.47 9.46v.01A9.75 9.75 0 0 0 12 21.75h1.35a2.75 2.75 0 0 0 2.64-3.5v-.02l-.25-.87v-.02c-.23-.8.37-1.59 1.2-1.59H19A2.75 2.75 0 0 0 21.75 13Zm-1.5-1.01a8.25 8.25 0 0 0-8.48-8.24 8.35 8.35 0 0 0-8.02 8.02v.01A8.25 8.25 0 0 0 12 20.25h1.35c.84 0 1.43-.79 1.21-1.59l-.26-.9v-.02a2.75 2.75 0 0 1 2.65-3.49H19c.7 0 1.25-.56 1.25-1.25v-1.01Z"
    }, null, -1)
  ])))
}
export default { render: render }